import React, { useState, useEffect, useCallback} from "react";
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { RESET_PASSWORD } from 'helpers/viewContent';
import * as actions from 'store/actions/index.js';
import {MAIN_LOGO} from 'utils/constant'
// imported
import * as Yup from 'yup';
import {resetPasswordForm_, resetPassword_} from 'store/services/authService';

const validationSchema = Yup.object().shape({
    new_password: Yup.string().required("Required").min(6, "Password must be at most 6 characters long"),
    confirm_password: Yup.string().required("Please confirm your password").oneOf([Yup.ref('new_password'), null], 'Passwords must match'), 
});

const validateData = async (data) => {
    try {
        await validationSchema.validate(data, { abortEarly: false });
        return { isValid: true, errors: {} };
    } catch (error) {
        const errors = {};
        error.inner.forEach((err) => {
            errors[err.path] = err.message;
        });
        return { isValid: false, errors };
    }
};

const ResetPassword = ({dispatch, userProfile, match}) => {
    const [validationErrors, setValidationErrors] = useState({});
    const [sending, setSending] = useState(false);
    const [success, setSuccess] = useState(false);
    const [fields, setfields] = useState({
        new_password:"",
        confirm_password: "",
        reset_token:""
    })
    const handleChange = useCallback(
        name => evt => {
          setfields(prevState => ({
            ...prevState,
            [name]: evt.target.value,
          }))
          setValidationErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
        },
        []
    )

    useEffect(() => {
        let isMounted = true;
        async function getData() {
            try {    
                let token = match ? match.params.token : '';
                dispatch(actions.persist_store({ loader:true }));
                await dispatch(resetPasswordForm_(token)).then((res) => {
                    if (isMounted) {
                        dispatch(actions.persist_store({ loader:false }));
                        setSuccess(false);
                    }
                });
            } catch(err) {
                dispatch(actions.persist_store({ loader:false }));
                if(err && err.data && err.data.message){
                    setSuccess(true);
                } 
            }  
        }
        getData();
        return () => {
            isMounted = false;
        };
    }, []);

    useEffect(() => {
        console.log('useEffect is running...');
        // rest of your code
    }, []);

    //submit setting data
    const handleSubmit = async (evt) => {
        try{
            evt.preventDefault();
            const validation = await validateData(fields);
            if (validation.isValid) {
                let query = {
                    ...fields,
                    reset_token : match ? match.params.token : '',
                }
                setSending(true)
                await dispatch(resetPassword_(query));
                setSending(false)
                setfields({
                    new_password:"",
                    confirm_password:""
                })
            } else {
                setValidationErrors(validation.errors);
            }
        } catch (err) {
            console.log(err);
            setSending(false)
        }
    }
    
    return(
        <>
        <Helmet title={RESET_PASSWORD.CURRENT_MODULE} />
        <div className="container-fluid page-body-wrapper full-page-wrapper">
            <div className="content-wrapper d-flex align-items-center auth">
                <div className="row flex-grow">
                    {!success &&
                    <div className="col-lg-4 mx-auto">
                        <div className="auth-form-light text-left p-5">
                            <div className="brand-logo">
                            <img src={MAIN_LOGO} className="loginLogo"/>
                            </div>
                            <h4>{RESET_PASSWORD.CURRENT_MODULE}</h4>
                            <h6 className="font-weight-light">{RESET_PASSWORD.MAIN_CONTENT}</h6>
                            <form className="forms-sample" onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <label for="exampleInputName1">New Password*</label>
                                    <input type="password" className="form-control" id="exampleInputName1" placeholder="******" name="new_password" onChange={handleChange("new_password")}
                                    value={fields.new_password}
                                    />
                                    {validationErrors.new_password && (
                                        <div className="text-danger">{validationErrors.new_password}</div>
                                    )}
                                </div>
                                <div className="form-group">
                                    <label for="exampleInputName1">Confirm Password*</label>
                                    <input type="password" className="form-control" id="exampleInputName1" placeholder="******" name="confirm_password" onChange={handleChange("confirm_password")}
                                    value={fields.confirm_password}
                                    />
                                    {validationErrors.confirm_password && (
                                        <div className="text-danger">{validationErrors.confirm_password}</div>
                                    )}
                                </div>
                               
                            <button type="submit" disabled={sending ? true : false} className="btn btn-gradient-primary me-2">{sending ?  'Loading...' : RESET_PASSWORD.BUTTON}</button>
                            </form>
                        </div>
                    </div>
                    }
                    {success &&
                    <div className="col-lg-4 mx-auto">
                        <div className="auth-form-light text-left p-5">
                            <h4>Link Expired</h4>
                        </div>
                    </div> 
                    } 
                </div>
            </div>
        </div>
        </>

    )
}
const mapStateToPros = (state) => {
    return{
        userProfile: state.Auth.user
    }
};
function mapDispatchToProps(dispatch) {
    return { dispatch };
}

export default connect(
  mapStateToPros,
  mapDispatchToProps
)(ResetPassword);